export default {"src":"/_next/static/image/public/images/ic_phone_white.d56c6c1079b9cd92d7757d9e020e6393.svg","height":14,"width":14};